// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2Ez83","savePackageButton":"ClientWallet_savePackageButton__1inJP"};